


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import {
	DxBox, DxItem
} from 'devextreme-vue/box';

import DxButton from 'devextreme-vue/button';
import DxCheckBox from 'devextreme-vue/check-box';

import {
	DxToolbarItem
} from 'devextreme-vue/popup';

import { Panel } from '@/components';


@Component({
	components: {
		DxBox, DxButton,
		DxCheckBox,
		DxItem,
		DxToolbarItem,
		Panel
	}
})
export default class ShareChartPanel extends Vue {

	@Prop({ type: Boolean, default: false }) showPanel!: boolean | null;
	@Prop({ type: String }) idChart!: string;

	internalShowPanel = false;
	shareWithCompany = true;

	get checkboxProps() {
		return {
			text: this.$t('share.allCompany')
		};
	}

	get shareButtonProps() {
		return {
			location: 'after',
			options: {
				icon: 'far fa-share-alt',
				onClick: this.onShareClick,
				stylingMode: 'outlined',
				text: this.$t('share.action'),
			},
			toolbar: 'bottom',
			widget: 'dxButton'
		};
	}

	onShareClick() {

	}

	@Watch('showPanel', { immediate: true })
	onShowPopupChange(newValue: boolean) {
		this.internalShowPanel = newValue;
	}

	@Watch('internalShowPanel')
	onInternalShowPopupChange(newValue: boolean) {
		this.$emit('update:show-panel', newValue);
	}

}

